
import { useTranslation } from 'react-i18next';
import { CheckCircle2, XCircle, AlertTriangle, ShieldCheck } from 'lucide-react';

export function BeforeAfterOley() {
  const { t } = useTranslation();

  const beforeItems = [
    t('beforeAfter.before.items.missedTheft'),
    t('beforeAfter.before.items.slowResponses'),
    t('beforeAfter.before.items.manualReview'),
    t('beforeAfter.before.items.lostRevenue')
  ];

  const afterItems = [
    t('beforeAfter.after.items.smartAI'),
    t('beforeAfter.after.items.alerts'),
    t('beforeAfter.after.items.shrinkageReduction'),
    t('beforeAfter.after.items.proactiveDeterrence')
  ];

  return (
    <section className="py-12 md:py-16 bg-white dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white sm:text-4xl mb-4">
            {t('beforeAfter.title')}
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            {t('beforeAfter.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Before Oley */}
          <div className="bg-gray-50 dark:bg-slate-800 rounded-xl shadow-lg overflow-hidden border border-gray-200 dark:border-slate-700">
            <div className="px-6 py-4 border-b border-gray-200 dark:border-slate-700">
              <h3 className="text-xl font-bold text-gray-900 dark:text-white flex items-center justify-center">
                <AlertTriangle className="h-5 w-5 text-primary-500 dark:text-primary-400 mr-2 flex-shrink-0" />
                {t('beforeAfter.before.title')}
              </h3>
            </div>
            <div className="p-6">
              <ul className="space-y-4">
                {beforeItems.map((item, index) => (
                  <li key={index} className="flex items-start">
                    <XCircle className="h-5 w-5 text-gray-400 dark:text-slate-500 mr-3 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700 dark:text-gray-300">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* After Oley */}
          <div className="bg-gray-50 dark:bg-slate-800 rounded-xl shadow-lg overflow-hidden border border-gray-200 dark:border-slate-700">
            <div className="px-6 py-4 border-b border-gray-200 dark:border-slate-700">
              <h3 className="text-xl font-bold text-gray-900 dark:text-white flex items-center justify-center">
                <ShieldCheck className="h-5 w-5 text-primary-500 dark:text-primary-400 mr-2 flex-shrink-0" />
                {t('beforeAfter.after.title')}
              </h3>
            </div>
            <div className="p-6">
              <ul className="space-y-4">
                {afterItems.map((item, index) => (
                  <li key={index} className="flex items-start">
                    <CheckCircle2 className="h-5 w-5 text-primary-500 dark:text-primary-400 mr-3 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700 dark:text-gray-300">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        
        <div className="w-full mt-16 text-center px-4">
          <div className="relative max-w-3xl mx-auto">
            <svg className="w-12 h-12 mx-auto text-gray-300 dark:text-slate-600 mb-6" fill="currentColor" viewBox="0 0 24 27">
              <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609.955 2.085 1.624 4.111 2.064 6.086.092.581-.41 1.127-.991 1.127-1.913 0-3.282 1.525-3.282 3.259v3.557h3.5c.511 0 .935.404.935.913 0 .5-.42.913-.935.913h-3.5v7.391h-7.5zm-14 0v-7.391c0-5.704 3.748-9.57 9-10.609.955 2.085 1.624 4.111 2.064 6.086.092.581-.41 1.127-.991 1.127-1.913 0-3.282 1.525-3.282 3.259v3.557h3.5c.511 0 .935.404.935.913 0 .5-.42.913-.935.913h-3.5v7.391h-7.5z" />
            </svg>
            <p className="text-xl font-light leading-relaxed text-gray-700 dark:text-gray-300 italic mb-6">
              {t('beforeAfter.quote')}
            </p>
            <div className="text-sm font-medium text-gray-500 dark:text-gray-400 tracking-wider">
              {t('beforeAfter.quoteAuthor')}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
